export default "__VITE_ASSET__8j6sOYav__"